import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { button } from "../../../../../../config";
import "../../../styles/ExpressionBuilder.css";

/**
 * Component for rendering expression builder modal footer
 * @param {Function} onClose - Close handler function
 * @param {Function} handleSaveExpression - Save expression handler
 * @param {boolean} isSaveDisabled - Whether save button should be disabled
 * @param {boolean} isSubmitting - Whether form is submitting
 * @returns {JSX.Element} Modal footer component
 * @author Abhishek Dhillon
 * @parent ExpressionBuilderModal
 */
const ModalFooter = ({ onClose, handleSaveExpression, isSaveDisabled = false, isSubmitting = false }) => {
  return (
    <div className='expression-builder-modal-footer'>
      <div className='d-flex expression-builder-gap-2 justify-content-end'>
        <button onClick={onClose} fillMode='outline' disabled={isSubmitting} id='cancel-switch-expression' className='btn btn-ghost'>
          {button.CLOSE}
        </button>
        <button
          type='button'
          onClick={() => handleSaveExpression()}
          disabled={isSaveDisabled}
          id='save-switch-expression'
          className='btn btn-primary'>
          {isSubmitting ? "Saving..." : button.SAVE}
        </button>
      </div>
    </div>
  );
};

export default ModalFooter;
